/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateUpdateTextDto,
  ErrorResponseOfPtw100BadRequestException,
  ErrorResponseOfPtw100ForbiddenException,
  ErrorResponseOfPtw100MaintenanceModeException,
  ErrorResponseOfPtw100NotFoundException,
  ErrorResponseOfPtw100UnauthorizedException,
  HistoryDto,
  ODataPostProcessedResultsOfTextDto,
  TextDto,
} from '../models/index';
import {
    CreateUpdateTextDtoFromJSON,
    CreateUpdateTextDtoToJSON,
    ErrorResponseOfPtw100BadRequestExceptionFromJSON,
    ErrorResponseOfPtw100BadRequestExceptionToJSON,
    ErrorResponseOfPtw100ForbiddenExceptionFromJSON,
    ErrorResponseOfPtw100ForbiddenExceptionToJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionToJSON,
    ErrorResponseOfPtw100NotFoundExceptionFromJSON,
    ErrorResponseOfPtw100NotFoundExceptionToJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionFromJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionToJSON,
    HistoryDtoFromJSON,
    HistoryDtoToJSON,
    ODataPostProcessedResultsOfTextDtoFromJSON,
    ODataPostProcessedResultsOfTextDtoToJSON,
    TextDtoFromJSON,
    TextDtoToJSON,
} from '../models/index';

export interface CreateTextRequest {
    createUpdateTextDto?: CreateUpdateTextDto;
}

export interface DeleteTextRequest {
    id: string;
}

export interface GetTextRequest {
    id: string;
}

export interface GetTextHistoryRequest {
    id: string;
}

export interface GetTextListRequest {
    $filter?: string;
    $search?: string;
    $top?: number;
    $skip?: number;
    $orderby?: string;
}

export interface UpdateTextRequest {
    id: string;
    createUpdateTextDto?: CreateUpdateTextDto;
}

export interface ValidateTextRequest {
    createUpdateTextDto?: CreateUpdateTextDto;
}

/**
 * 
 */
export class TextsApi extends runtime.BaseAPI {

    /**
     * Adds a new entity
     */
    async createTextRaw(requestParameters: CreateTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/texts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateTextDtoToJSON(requestParameters['createUpdateTextDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 201: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TextDtoFromJSON(jsonValue), "TextDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TextDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Adds a new entity
     */
     async createText(requestParameters: CreateTextRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TextsApi['createTextRaw']>>, TextDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TextDto;

         const response = this.createTextRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Deletes the entity with the given id.
     */
    async deleteTextRaw(requestParameters: DeleteTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteText().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/texts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     * Deletes the entity with the given id.
     */
     async deleteText(requestParameters: DeleteTextRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TextsApi['deleteTextRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.deleteTextRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns one entity for detail view.
     */
    async getTextRaw(requestParameters: GetTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getText().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/texts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TextDtoFromJSON(jsonValue), "TextDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TextDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Returns one entity for detail view.
     */
     async getText(requestParameters: GetTextRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TextsApi['getTextRaw']>>, TextDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TextDto;

         const response = this.getTextRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns the catalog of all texts.
     */
    async getTextCatalogRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/texts/catalog`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						 return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TextDtoFromJSON), "TextDto" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TextDtoFromJSON));
					}
				}
				// -- Responses
    }

    /**
     * Returns the catalog of all texts.
     */
     async getTextCatalog(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TextsApi['getTextCatalogRaw']>>, Array<TextDto>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<TextDto>;

         const response = this.getTextCatalogRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns the change history of the given text.
     */
    async getTextHistoryRaw(requestParameters: GetTextHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTextHistory().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/texts/{id}/history`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						 return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HistoryDtoFromJSON), "HistoryDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HistoryDtoFromJSON));
					}
				}
				// -- Responses
    }

    /**
     * Returns the change history of the given text.
     */
     async getTextHistory(requestParameters: GetTextHistoryRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TextsApi['getTextHistoryRaw']>>, Array<HistoryDto>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<HistoryDto>;

         const response = this.getTextHistoryRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns a list of entities for grid view.
     */
    async getTextListRaw(requestParameters: GetTextListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        if (requestParameters['$filter'] != null) {
            queryParameters['$filter'] = requestParameters['$filter'];
        }

        if (requestParameters['$search'] != null) {
            queryParameters['$search'] = requestParameters['$search'];
        }

        if (requestParameters['$top'] != null) {
            queryParameters['$top'] = requestParameters['$top'];
        }

        if (requestParameters['$skip'] != null) {
            queryParameters['$skip'] = requestParameters['$skip'];
        }

        if (requestParameters['$orderby'] != null) {
            queryParameters['$orderby'] = requestParameters['$orderby'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/texts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfTextDtoFromJSON(jsonValue), "ODataPostProcessedResultsOfTextDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfTextDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Returns a list of entities for grid view.
     */
     async getTextList(requestParameters: GetTextListRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TextsApi['getTextListRaw']>>, ODataPostProcessedResultsOfTextDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = ODataPostProcessedResultsOfTextDto;

         const response = this.getTextListRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Updates an entity, if existing
     */
    async updateTextRaw(requestParameters: UpdateTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateText().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/texts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateTextDtoToJSON(requestParameters['createUpdateTextDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TextDtoFromJSON(jsonValue), "TextDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TextDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Updates an entity, if existing
     */
     async updateText(requestParameters: UpdateTextRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TextsApi['updateTextRaw']>>, TextDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TextDto;

         const response = this.updateTextRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Validates an entity without adding or updating it.
     */
    async validateTextRaw(requestParameters: ValidateTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/texts/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateTextDtoToJSON(requestParameters['createUpdateTextDto']),
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     * Validates an entity without adding or updating it.
     */
     async validateText(requestParameters: ValidateTextRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TextsApi['validateTextRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.validateTextRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

}
